import { render, staticRenderFns } from "./TradeForm.vue?vue&type=template&id=8f649502"
import script from "./TradeForm.vue?vue&type=script&lang=js"
export * from "./TradeForm.vue?vue&type=script&lang=js"
import style0 from "./TradeForm.vue?vue&type=style&index=0&id=8f649502&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports